export { useEstimatedDeliveryDates } from '@/data/Content/EstimatedDeliveryDates/useEstimatedDeliveryDates';
export { getResolvedDeliveryDate } from '@/data/Content/EstimatedDeliveryDates/utils';
export type {
	EstimatedDeliveryDates,
	UseEstimatedDeliveryDatesOptions,
} from '@/data/Content/EstimatedDeliveryDates/types';
